import React, { useRef, useState } from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Checkbox } from '../../components/Checkbox';
import { cn } from '../../utils/cn';

const FilterField = ({ options, selectedOptions, setSelectedOptions, label, prefix, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectRef = useRef(null);
  const detailsRef = useRef(null);

  const onToggle = (value) => {
    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== value));
    } else {
      setSelectedOptions([...selectedOptions, value]);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full z-10 bg-black bg-opacity-20"
          onClick={() => {
            setIsOpen(false);
            if (detailsRef.current) {
              detailsRef.current.removeAttribute('open');
            }
          }}
        />
      )}

      <div
        className={cn('px-2 h-[38px] flex gap-x-2 items-center relative cursor-pointer border border-gray-300 rounded-lg bg-white', className)}
        ref={selectRef}>
        <details ref={detailsRef} className="relative w-full" onToggle={(e) => setIsOpen(e.currentTarget.open)}>
          <summary className="list-none text-gray-400 flex gap-x-2 items-center">
            {prefix && prefix}
            <span className={'text-sm pr-2'}>{label}</span>
            <FilterAltOutlinedIcon className={'ml-auto'} />
          </summary>

          <div className="absolute font-normal min-w-[260px] left-[-8px] top-[33px] z-10 p-2 overflow-y-auto max-h-[80vh] max-w-xs bg-white rounded-xl flex flex-col gap-1">
            {options && options.length > 0
              ? options.map((option) => {
                  const { name, value, icon } = option;
                  const isSelected = selectedOptions.includes(value);
                  return <Checkbox icon={icon} key={value} checked={isSelected} label={name} onChange={() => onToggle(value)} />;
                })
              : null}
          </div>
        </details>
      </div>
    </>
  );
};

export default FilterField;
